import { CardProps } from '@/components/atoms/Card';
import * as S from './styles';
import { CSSProperties, useTheme } from 'styled-components';
import { IconeChippu } from '@/components/atoms/Icones/IconeChippu';
import Text from '@/components/atoms/Text';
import { IconeEstrela } from '@/components/atoms/Icones/IconeEstrela';
import useBreakpoint from '@/hooks/useBreakpoint';

interface NotaFichaProps {
  $nota: number;
  $tipo: 'comunidade' | 'chippu';
  $cardProps?: CardProps;
  style?: CSSProperties;
}

export default function NotaFicha(props: NotaFichaProps) {
  const { $nota, $tipo, style } = props;
  const theme = useTheme();
  const { breakpoint } = useBreakpoint();

  return (
    <S.Container style={style}>
      {$tipo === 'chippu' ? (
        <IconeEstrela size={24} color="#FFAC33" $fillColor="#FFAC33" />
      ) : (
        <IconeChippu size={20} color={theme.colors.accent.accent[9]} />
      )}
      <Text
        $size={breakpoint === 'mobile' ? 4 : 5}
        $color="neutral"
        $weight="bold"
        $align="center"
        $highContrast={true}
        $text={$tipo === 'chippu' ? 'Chippu' : 'Comunidade'}
      />
      <Text
        $size={3}
        $color={theme.colors.accent.accent[9]}
        $weight="bold"
        $align="center"
        $highContrast={false}
        $text={`${$nota}/5`}
      />
    </S.Container>
  );
}
